import { ImageIcon } from 'lucide-react';
import { ImageStoryPanelRetryButton } from '@/components/narration/ImageStoryPanelRetryButton';

/**
 * Thumbnail slot: image preview or missing-image retry affordance.
 */
export function ImageStoryPanelImageSlot({
  panelImage,
  imageUrl,
  alt,
  busy = false,
  onSelect,
  onRetry,
  disabled = false,
  className = '',
  imageClassName = 'w-full h-20 sm:h-28 object-cover pointer-events-none',
  slotClassName = 'shrink-0 w-24 sm:w-32 h-20 sm:h-28 rounded-md border border-dashed border-[var(--glass-border)] bg-black/10 flex flex-col items-center justify-center gap-1.5 px-1',
  testId,
}) {
  if (panelImage?.hasImage && imageUrl) {
    return (
      <div className={`relative shrink-0 w-24 sm:w-32 ${className}`.trim()}>
        <button
          type="button"
          onClick={onSelect}
          className="block w-full"
          disabled={disabled}
          data-testid={testId}
        >
          <img
            src={imageUrl}
            alt={alt}
            draggable={false}
            className={imageClassName}
          />
        </button>
        {panelImage.canRegenerate ? (
          <div
            className="absolute top-1 right-1 z-10"
            onClick={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()}
          >
            <ImageStoryPanelRetryButton
              panelImage={panelImage}
              busy={busy}
              variant="inline"
              className="h-6 w-6 bg-black/60"
              onClick={onRetry}
            />
          </div>
        ) : null}
      </div>
    );
  }

  if (panelImage?.canRetry) {
    return (
      <div
        className={`${slotClassName} ${className}`.trim()}
        data-testid={testId || `image-story-scene-missing-${panelImage.panelNumber}`}
      >
        <ImageIcon className="w-5 h-5 narration-wizard-hint opacity-60" />
        <ImageStoryPanelRetryButton
          panelImage={panelImage}
          busy={busy}
          variant="thumb"
          onClick={onRetry}
        />
      </div>
    );
  }

  return null;
}
